export default __webpack_public_path__ + "static/media/right_click.dd25f05a.gif";